// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import '@/styles/index.scss' // global css
import App from './App'
import router from './router'
import store from './store'
import "babel-polyfill"
import './common/js/rem.js' // 初始化样式
import './common/css/base.css' // 初始化样式
import './common/css/x.css' // 初始化样式
import './common/css/jkm.css' // 初始化样式
import VueClipboard from 'vue-clipboard2'
import moment from 'moment'
import {getToken,} from '@/utils/auth'

Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})
router.beforeEach((to, from, next) => {
  // 验证是否需要登陆
  if (to.matched.some(res => res.meta.requireAuth)) {
    if (getToken()) {
      next()
    } else {
      next({
        path: '/', // 未登录则跳转至login页面
        query: {redirect: to.fullPath} // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面
      })
    }
  } else {
    next()
  }
})
Vue.use(VueClipboard)
Vue.use(MintUI)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js